"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var UiStateController_1 = require("../../../../../shared/UiStateController");
var routes_1 = require("../../../../shared/includes/routes");
var AppCapchaTemplateEditor_1 = require("./component/AppCapchaTemplateEditor");
var AppCapchaTemplatesList_1 = require("./component/AppCapchaTemplatesList");
var PAppCapchasList = /** @class */ (function (_super) {
    __extends(PAppCapchasList, _super);
    // private SID_AC: number;
    function PAppCapchasList(props) {
        return _super.call(this, props) || this;
    }
    PAppCapchasList.prototype.componentWillMount = function () {
        // this.SID_AC = this.props.listAppCountries.Subscribe("*", (id, data) => {
        //     this.setState({ avail_countries: data.data })
        //  });
        var _this = this;
        this.SID_STATE = this.props.state.Subscribe("*", function (id, data) {
            _this.setState({
                page_size: data.tablePageSize,
            });
        });
        this.setState({
            edit_mode: "LIST",
            record: null,
            page_num: 1,
            page_size: this.props.state.getTablePageSize(),
        }, function () {
            // this.props.listAppCountries.LoadData();
        });
    };
    PAppCapchasList.prototype.componentWillUnmount = function () {
        this.props.state.UnSubscribe(this.SID_STATE);
        // this.props.listAppCountries.UnSubscribe(this.SID_AC);
    };
    PAppCapchasList.prototype.onNewClick = function () {
        this.setState({ edit_mode: "NEW", record: null });
    };
    PAppCapchasList.prototype.onEditClick = function (val) {
        this.setState({ edit_mode: "EDIT", record: val });
    };
    PAppCapchasList.prototype.onGoBackClick = function () {
        this.setState({ edit_mode: "LIST", record: null });
    };
    PAppCapchasList.prototype.onPageConfigChange = function (PageNum, PageSize) {
        var _this = this;
        this.setState({ page_num: PageNum }, function () {
            _this.props.state.setTablePageSize(PageSize, true);
        });
    };
    PAppCapchasList.prototype.getRenderObject = function () {
        if (this.state.edit_mode === "NEW") {
            return (React.createElement(AppCapchaTemplateEditor_1.default, { data: this.props.data, state: this.props.state, record: null, onGoBack: this.onGoBackClick.bind(this), 
                //availCountries={this.state.avail_countries}
                dialogSelectImage: this.props.dialogSelectImage }));
        }
        if (this.state.edit_mode === "EDIT") {
            return (React.createElement(AppCapchaTemplateEditor_1.default, { data: this.props.data, state: this.props.state, record: this.state.record, onGoBack: this.onGoBackClick.bind(this), 
                // availCountries={this.state.avail_countries}
                dialogSelectImage: this.props.dialogSelectImage }));
        }
        if (this.state.edit_mode === "LIST") {
            return (React.createElement(AppCapchaTemplatesList_1.default, { data: this.props.data, state: this.props.state, onNewClick: this.onNewClick.bind(this), onEditClick: this.onEditClick.bind(this), onPageConfigChanged: this.onPageConfigChange.bind(this), pageNum: this.state.page_num, pageSize: this.state.page_size }));
        }
        throw "No available render for active edit mode -> " + this.state.edit_mode;
    };
    PAppCapchasList.prototype.render = function () {
        return this.getRenderObject();
    };
    PAppCapchasList.getPageDescription = function (state) {
        return {
            icon: "puzzle-piece",
            iconKind: "normal",
            itemId: "item-" + routes_1.routes.page_security_capchas + "-id",
            itemTitle: "Шаблоны капчи",
            route: routes_1.routes.page_security_capchas,
            docType: UiStateController_1.UIDocumentType.udtRegularPage
        };
    };
    return PAppCapchasList;
}(React.Component));
exports.default = PAppCapchasList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/app_capcha/ui/PAppCapchasList.tsx
// module id = 2575
// module chunks = 0